import React, { FC } from 'react'
import { Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

const Title = withStyles({
  root: {
    fontSize: '35px',
    backgroundColor: 'white'
  }
})(Typography)

interface Props {
  title: string
  subtitle: string
}

const Header: FC<Props> = ({ title, subtitle }) => {
  return (
    <>
      <div className="flex flex-col gap-y-[20px]">
        <Title variant="h1">{title}</Title>
        <Typography color="textPrimary" className="text-center">
          {subtitle}
        </Typography>
      </div>
    </>
  )
}

export default Header
